import _ from 'lodash'; // TODO(michael.g): Replace with importa of _.get, _.set, _.pick, and _.cloneDeep.

import Utility from '../classes/Utility';
import EventEmitter from './event-emitter';

const UNLOCKED_PERMANENTLY = 'unlocked-permanently';

export default class MitreTable extends EventEmitter {

    static paramNames = [
        'collectionKey',
        'filters',
        'currentTabKey',
        'sortBy',
        'theme',
        'specialTheme',
        'defaultFilters'
    ];

    static InteractionType = {
        TAB_CHANGE: 'tab-change',
        FILTER_CHANGE: 'filter-change',
        PAGE_CHANGE: 'page-change',
        SORT_CHANGE: 'sort-change',
    };

    static LocalStorageKey = {
        INTERACTIONS_LOCKED_UNTIL: 'MitreTable.interactionsLockedUntil',
    };

    constructor(tableKey) {
        super();

        if (this.constructor._instances && tableKey in this.constructor._instances) {
            throw new Error(`${this.constructor.name} ${tableKey} already exists!`);
        }

        this._tableKey = tableKey;

        // nb! For the time being we decided not to persist the params in localStorage.
        // They are a clean slate on every page load.
        // this._params = this.constructor.readTableParamsFromLocalStorage(tableKey);
        this._params = {};
    }

    get tableKey() { return this._tableKey; }

    setParam(paramPath, value, saveFlag = true) {
        _.set(this._params, paramPath, value);
        saveFlag && this.save();
    }

    getParams() {
        return _.cloneDeep(this._params);
    }

    save() {
        // nb! For the time being we decided not to persist the params in localStorage.
        // this.constructor.saveTableParamsToLocalStorage(this._tableKey, this._params);
    }

    static getByTableKey(tableKey) {
        if (!this._instances) {
            this._instances = {};
        }
        if (this._instances[tableKey]) {
            return this._instances[tableKey];
        }
        this._instances[tableKey] = new this(tableKey);
        return this._instances[tableKey];
    }

    static readTableParamsFromLocalStorage(tableKey) {
        const lsKey = this.makeLocalStorageKeyForTablePrams(tableKey);
        const params = _.pick(Utility.getFromLocalStorage(lsKey) || {}, this.paramNames);

        // Because collectionKey is always present, if it hasn't been stored yet,
        // we conclude that the table is being seen for the first time. Thus, it (explicitly) has no state.
        if (!params.collectionKey) return {};

        return params;
    }

    static saveTableParamsToLocalStorage(tableKey, params) {
        const validParams = _.pick(params, this.paramNames);
        const lsKey = this.makeLocalStorageKeyForTablePrams(tableKey);
        window.localStorage.setItem(lsKey, JSON.stringify(validParams));
    }

    static makeLocalStorageKeyForTablePrams(tableKey) {
        return `MitreTable/${tableKey}/params`;
    }

    static areInteractionsLocked(tableKey) {
        const lockedUntil = window.localStorage.getItem(this.LocalStorageKey.INTERACTIONS_LOCKED_UNTIL);
        if (lockedUntil === UNLOCKED_PERMANENTLY) return false;
        return lockedUntil && (new Date(Number(lockedUntil))).getTime() > Date.now();
    }

    static areInteractionsPermanentlyUnlocked() {
        const lockedUntil = window.localStorage.getItem(this.LocalStorageKey.INTERACTIONS_LOCKED_UNTIL);
        return lockedUntil === UNLOCKED_PERMANENTLY;
    }

    static lockInteractions() {
        window.localStorage.setItem(
            this.LocalStorageKey.INTERACTIONS_LOCKED_UNTIL,
            Date.now() + 24 * 60 * 60 * 1000);
    }

    static unlockInteractionsPermanently() {
        window.localStorage.setItem(
            this.LocalStorageKey.INTERACTIONS_LOCKED_UNTIL, UNLOCKED_PERMANENTLY);
    }
};
